import axios from "axios";
import _ from "lodash";

const bagnoProcessModule = {
  namespaced: true,
  state: {
    form: {
      process_type: null,
      contents_in: [],
      contents_out: []
    }
  },
  getters: {
    countIn: state => {
      return state.form.contents_in.length;
    },
    countOut: state => {
      return state.form.contents_out.length;
    },
    // Deprecated -->
    getFruitInProcess: state => {
      let fruit_id = '';
      const length = state.form.contents_in.length;
      if (length > 0) {
        fruit_id = state.form.contents_in[length - 1].fruit_id;
      }
      return fruit_id
    },
    // <-- Deprecated
    totalInNet: state => {
      return state.form.contents_in.reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0).toFixed(2);
    },
    totalOutNet: state => {
      return state.form.contents_out.reduce(function(acc, item){
        if(item.is_devolution != true){
          return acc + parseFloat(item.net_kilograms);
        }else{
          return acc + parseFloat(0);
        }
      }, 0).toFixed(2);
     // return state.form.contents_out.reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0).toFixed(2);
    },
    getDevolutionOutNet: (state) => () => {
      var sum=0;
      for(const index in state.form.contents_out){
        if(state.form.contents_out[index].is_devolution==true){
          sum = sum + parseFloat(state.form.contents_out[index].net_kilograms)
        }
      }
      return sum.toFixed(2);
    },
    differenceNet: (state, getters) => {
      return ((getters.totalInNet - getters.getDevolutionOutNet()) - getters.totalOutNet).toFixed(2);
    },
    totalInGross: state => {
      return state.form.contents_in.reduce((acc, item) => acc + parseFloat(item.gross_kilograms), 0).toFixed(2);
    },
    totalOutGross: state => {
      return state.form.contents_out.reduce(function(acc, item){
        if(item.is_devolution != true){
          return acc + parseFloat(item.gross_kilograms);
        }else{
          return acc + parseFloat(0);
        }
      }, 0).toFixed(2);
      //return state.form.contents_out.reduce((acc, item) => acc + parseFloat(item.gross_kilograms), 0).toFixed(2);
    },
    totalInQuantity: state => {
      return state.form.contents_in.reduce((acc, item) => acc + item.quantity, 0);
    },
    totalOutQuantity: state => {
      return state.form.contents_out.reduce(function(acc, item){
        if(item.is_devolution != true){
          return acc + item.quantity;
        }else{
          return acc + 0;
        }
      }, 0);
      //return state.form.contents_out.reduce((acc, item) => acc + item.quantity, 0);
    },
    totalSaleable: state => {
      let value = state.form.contents_out.filter(({product_type}) => product_type.waste === false)
        .reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0).toFixed(2);
      return isNaN(value) ? 0.00 : value
    },
    totalQuantitySaleable: state => {
      let value = state.form.contents_out.filter(({product_type}) => product_type.waste === false)
        .reduce((acc, item) => acc + parseInt(item.quantity), 0).toFixed(0);
      return isNaN(value) ? 0 : value
    },
    checkBrechaComercial: state => {
        let n = _.find(state.form.contents_out, el => { return el.product_type.name === 'BRECHA COMERCIAL' });
        return !_.isEmpty(n);
      },
    totalWaste: state => {
      let value = state.form.contents_out.filter(({product_type}) => product_type.waste === true)
        .reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0).toFixed(2);
      return isNaN(value) ? 0.00 : value
    },
    currentLotInProcess: state => {
      let currentLot;
      const lenght = state.form.contents_in.length;
      if (lenght > 0) {
        currentLot = state.form.contents_in[lenght - 1].lot;
      } else {
        currentLot = "-";
      }
      return currentLot
    },
    // Deprecated -->
    currentProductsInProcess: state => {
      return _(state.form.contents_in)
        .groupBy('product_id')
        .map((product_code, id) => ({
          value: {"id":parseInt(id)},
          text: _.get(_.find(product_code, 'product_code'), 'product_code') + " - " +
            _.get(_.find(product_code, 'product'), 'product'),
        }))
        .value()
    },
    // <-- Deprecated
    lotsInProcess: state => {
      // Se agrupa por Lote-Código: 4YO13E-3020000 y se entrega la información necesaria para que los botones funcionen
      return _(state.form.contents_in).groupBy(i=>i.lot + '-' + i.product_code).map((content, id) => ({
        lot: id,
        lot_id: _.map(content, 'lot_id')[0],
        product_id: _.map(content, 'product_id')[0],
        fruit_id: _.map(content, 'fruit_id')[0],
        product_name: _.map(content, 'product_name')[0],
        product_code: _.map(content, 'product_code')[0],
        net_kilograms_sum_in: _.sumBy(content, item => Number(item.net_kilograms)).toFixed(2),
        net_kilograms_sum_out: state.form.contents_out.map(i => (
          {
            lot_product:(i.lot + '-' + i.product_reference_code),
            net_kilograms: i.net_kilograms
          })).filter(i => i.lot_product === id)
          .reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0).toFixed(2),
      })).value()
    },
  },
  mutations: {
    addRowsIn(state, payload) {
      state.form.contents_in.unshift(payload);
    },
    addRowsOut(state, payload) {
      state.form.contents_out.unshift(payload);
    },
    deleteRow(state, payload) {
      let array = [];
      if (payload.table_type === 0) {
        array = state.form.contents_in;
      } else {
        array = state.form.contents_out;
      }
      array.splice(payload.index, payload.index >= 0 ? 1 : 0);
    },
    updateProcessType(state, payload) {
      state.form.process_type = payload;
    },
    updateProcess(state, payload) {
      state.form = payload;
    },
    cleanProcess(state) {
      state.form = {
        process_type: null,
        contents_in: [],
        contents_out: [],
      }
    }

  },
  actions: {
    addRowsIn: ({commit}, payload) => {
      commit('addRowsIn', payload);
    },
    addRowsOut: ({commit}, payload) => {
      commit('addRowsOut', payload);

    },
    deleteRow: ({commit}, payload) => {
      commit('deleteRow', payload);
    },
    updateProcessType({commit}, payload) {
      commit('updateProcessType', payload);
    },
    updateProcess({commit}, payload) {
      commit('updateProcess', payload);
    },
    cleanProcess({commit}) {
      commit('cleanProcess');
    }
  }
};

export default bagnoProcessModule;
